export default __webpack_public_path__ + "static/avatar6-23664db4b2cea22019179edb4d64f8f4.png";